import { useRouter } from 'next/router';
import { StaticImage, TextButton, XSSShield, OperationText } from '@/components';
import moment from 'moment';
import { useBodyClassEffect, useSyncTitleContents } from '@/hooks';
import { useEffect, useState } from 'react';
import { cx } from '@emotion/css';

const NewsDetail = ({ newsData }) => {
  useBodyClassEffect('subHeader2');
  const router = useRouter();
  const { titleRef, contentMarginTop } = useSyncTitleContents({
    defaultOptions: {
      contentMarginTop: 179,
    },
  });
  const { news, tags } = newsData;
  const { query } = router;
  const [isFixed, setIsFixed] = useState(false);

  const toNewsList = () => {
    const { type = '', page = 1 } = query;
    const newQuery = { type, page };
    const newURL = new URLSearchParams(newQuery);

    return router.push(`/news/list?${newURL}`);
  };

  useEffect(() => {
    const handleResizeAndScroll = () => {
      const winW = window.innerWidth;
      const yOffset = window.scrollY;

      if (winW <= 1456) {
        setIsFixed(false);
      } else if (yOffset > 170) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener('resize', handleResizeAndScroll);
    window.addEventListener('scroll', handleResizeAndScroll);
    return () => {
      window.removeEventListener('resize', handleResizeAndScroll);
      window.removeEventListener('scroll', handleResizeAndScroll);
    };
  }, []);

  return (
    <div id="content">
      <div className="cnts">
        <div className="newsDetailsBody">
          <div className={cx('newsDetailsTitle', isFixed && 'fixedPosition')}>
            <div ref={titleRef}>
              <h2 className={'sTit'}>
                / 새소식<span>News</span>
              </h2>
              <dl>
                <dt>{news?.title}</dt>
                <dd>
                  <StaticImage src="../static/images/contents/news/icon_eye.png" alt="" />
                  {news?.viewCount}
                  <span>|</span>
                  {moment(news?.createdDate).format('YYYY-MM-DD')}
                </dd>
              </dl>
            </div>
            <StaticImage src="../static/images/contents/news/icon_arrow_move.png" alt="" />
          </div>
          <div className="newsDetailsContent" style={{ marginTop: contentMarginTop }}>
            <OperationText>
              <XSSShield className="newsDetailsText" content={news?.content} />
            </OperationText>
            <div className="newsDetailsTag">
              <ul>
                {tags?.map((tag) => (
                  <li key={tag.id}>
                    <a>{tag.name}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="newsDetailsBut">
              <TextButton onClick={toNewsList} type="button" pcBorderWidth={3}>
                /목록으로
              </TextButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsDetail;
